export default __webpack_public_path__ + "img/close-circle.f05bc3fe.svg";